export const IGNORE_ERRORS = [
  'top.GLOBALS',
  'originalCreateNotification',
  'canvas.contentDocument',
  'MyApp_RemoveAllHighlights',
  'http://tt.epicplay.com',
  "Can't find variable: ZiteReader",
  'jigsaw is not defined',
  'ComboSearch is not defined',
  'http://loading.retry.widdit.com/',
  'atomicFindClose',
  'fb_xd_fragment',
  'bmi_SafeAddOnload',
  'EBCallBackMessageReceived',
  '_gCrWeb',
  'conduitPage',
  "null is not an object (evaluating 'elt.parentNode')",
  'plugin.setSuspendState is not a function',
  'Extension context invalidated',
  'webkit-masked-url:',
  "can't access dead object",
  /Cannot redefine property: (solana|ethereum|googletag)/i,
  /undefined is not an object \(evaluating 'a\..'\)/i,
  'Permission denied to access property',
  "Can't find variable: gmo",
  'Script error.',
  '_avast_submit',
  'Error: Request failed with status code 403',
  'doLogout',
  'failedLogout',
  'sharedStorage is disabled',
  "Can't find variable: _AutofillCallbackHandler",
  'Error invoking postMessage: Java object is gone',
  'detectIncognito cannot determine the browser',
  /trackpoint[/-]async/i,
  /adform/i,
  "Failed to execute 'readText' on 'Clipboard'",
  'The request is not allowed by the user agent or the platform in the current context',
  'Clipboard read request was blocked due to lack of user activation',
  'Clipboard read operation is not allowed',
  'NotAllowedError: Read permission denied.',
  'NotAllowedError: Document is not focused.',
  '[object XMLHttpRequest]'
]

export const DENY_URLS = [
  /pagead\/js/i,
  /graph\.facebook\.com/i,
  /connect\.facebook\.net\/en_US\/all\.js/i,
  /eatdifferent\.com\.woopra-ns\.com/i,
  /static\.woopra\.com\/js\/woopra\.js/i,
  /extensions\//i,
  /^chrome(-extension)?:\/\//i,
  /^moz-extension:\/\//i,
  /^safari(-web)?-extension:\/\//i,
  /webkit-masked-url/i,
  /127\.0\.0\.1:4001\/isrunning/i,
  /webappstoolbarba\.texthelp\.com\//i,
  /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
  /kaspersky-labs\.com/i,
  /adform\.net/i,
  /trackpoint[/-]async/i,
  // Analytics/tagging
  /tagging\.airbaltic\.com/i,
  /logx\.optimizely\.com/i,
  /consentcdn\.cookiebot\.com/i,

  // Google tracking
  /doubleclick\.net/i,
  /google\.com\/ccm/i,
  /google\.com\/pagead/i
]

export const SENTRY_REQUEST_HEADER_ALLOWLIST = [
  'accept',
  'accept-encoding',
  'accept-language',
  'cf-cache-status',
  'cf-connecting-ip',
  'cf-ipcountry',
  'cf-ray',
  'cf-visitor',
  'cdn-loop',
  'host',
  'referer',
  'sec-fetch-dest',
  'sec-fetch-mode',
  'sec-fetch-site',
  'true-client-ip',
  'user-agent',
  'x-backend-source',
  'x-cache-status',
  'x-forwarded-for',
  'x-forwarded-host',
  'x-forwarded-proto',
  'x-real-ip',
  'x-request-id'
] as const

export const SENTRY_REQUEST_HEADER_TAGS = [
  'cf-cache-status',
  'cf-ipcountry',
  'cf-ray',
  'x-backend-source',
  'x-cache-status',
  'x-request-id'
] as const

export const RELEASE_IN_PROGRESS_SENTRY_EVENT_TYPE = 'release_in_progress'
export const RELEASE_IN_PROGRESS_SENTRY_MESSAGE = 'Release in progress active'
